export const KEY_TUTORIAL_MEMORY = "tutorial_memory";

export interface ElementMemory {

    image: any;
    clicked: boolean;
    completed: boolean;
}